import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useSelector } from "react-redux";

import campaign from "@src/assets/images/vyrill/icons/campaign_icon.png";
import youtube from "@src/assets/images/vyrill/reports/youtube_icon.png";
import tiktok from "@src/assets/images/vyrill/icons/tiktok_icon.png";
import instagram from "@src/assets/images/vyrill/icons/instagram_icon.png";
import facebook from "@src/assets/images/vyrill/icons/facebook_icon.png";
import googledrive from "@src/assets/images/vyrill/icons/google_drive_icon.png";
import dropbox from "@src/assets/images/vyrill/icons/dropbox_icon.png";
import crossIcon from "@src/assets/images/vyrill/icons/cross_icon.png";
import selectIcon from "@src/assets/images/vyrill/icons/selected_icon.png";

import { useState } from "react";
import DateRange from "./DateRange";
import { SortBy } from "./SVGs/SortBy";
import CampaignSortBy from "../Pages/Video/Components/Campaign/CampaignSortBy";
import { divide } from "lodash";
// import SelectedDate from "../../Dashborad/Components/SelectedDate";

const platformData = [
  { name: "Youtube", icon: youtube },
  { name: "Tiktok", icon: tiktok },
  { name: "Instagram", icon: instagram },
  // { name: "Facebook", icon: facebook },
  { name: "GoogleDrive", icon: googledrive },
  { name: "Dropbox", icon: dropbox },
];

const customStyles = {};
const VideoHeaderNew = ({
  tabs,
  tab,
  handleChangeTab,
  CampaignCards,
  loading,
}: any) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {(CampaignCards.length !== 0 || tab !== "ACTIVE" || loading) && (
        <>
          <div className="tab-outer">
            {tabs?.map((i: any, index: any) => (
              <div
                key={index}
                onClick={() => handleChangeTab(i?.value)}
                role="button"
                className={`tab-item${i?.value === tab ? "-active" : " "}`}
              >
                {i.name}
              </div>
            ))}
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <SortBy />
              </div>
              <div style={{ marginLeft: "5px", color: "black" }}>Sort by</div>
              <div style={{ marginLeft: "10px" }}>
                <CampaignSortBy />
              </div>
            </div>
          </div>
        </>
      )}
      {/* <div>
        

      <div className="d-flex justify-content-between align-items-center">
        <div className="">
          <SortBy />
          Sort by
          <div
            className="me-1 text-left"
            style={{ marginLeft: "2px", zIndex: 2 }}
          >
            <CampaignSortBy />
          </div>
        </div>
      </div>
      </div> */}
    </div>
  );
};

export default VideoHeaderNew;
